/**
 * 奈良県 名物めし 12段階（コンテンツデータ）。
 *
 * 数値（radius / mass / score / unlockScore）は他県と同じテンプレート。
 * 11品が農水省「うちの郷土料理」奈良県の30品から、1品（奈良漬）が奈良市観光協会の公式から。
 *
 * まなめはりは使わない。
 *  和歌山（Lv12 めはりずし）と同じ「漬け菜の葉でご飯をまるごと包んだ握り飯」になる。
 *  熊野の名物として知られるのは和歌山側なので、そちらに譲った。かわりに七色お和えを入れている。
 *
 * 鮎寿司も使わない。
 *  京都の鯖寿司、高知のさばの姿ずし、徳島のボウゼの姿寿司、和歌山のさんまずしと、
 *  すでに「魚を一尾のせた棒寿司」が4品ある。5品目は盤面で見分けがつかない。
 *  かわりに Lv10 を奈良茶飯にしている。
 *
 * 柿の葉寿司について。
 *  鳥取（Lv8 柿の葉寿司）と同じ名前になるが、中身が違う。
 *  鳥取（智頭町）は塩マスと山椒で、淡紅色の身と緑の粒。包みは少しずつ重なる。
 *  奈良（五條市・吉野）は塩サバで、銀青の皮と白い身。箱に詰めて一晩重しをかける押し寿司なので、
 *  角の立った四角い包みが整然と並ぶ。この二点を絵で分けている。
 *
 * 形のばらつき。
 *  半透明の四角（葛餅）／濃い飴色の細長い切片（奈良漬）／平たい半月（しきしき）／
 *  さらりとした粥（茶粥）／棒状の乾麺の束（三輪そうめん）／枝に連なる葉包み（でんがら）／
 *  小判形（いもぼた）／七色の野菜（七色お和え）／角の立った四角い葉包みの列（柿の葉寿司）／
 *  大豆の入った茶色い飯（奈良茶飯）／きな粉の丸餅（雑煮）／白い牛乳スープ（飛鳥鍋）。
 *  器を描く例外は茶粥・大和の雑煮・飛鳥鍋の3つ。雑煮は椀から出した餅を主役にしている。
 *
 * 調査で出てきた「書いてはいけないこと」を反映している。
 *  - 「日本一」「最古」は限定語ごと引用する。
 *    「日本一長い生活用鉄線吊り橋」／「屋外に立つ古塔としてはわが国最小の五重塔」／
 *    「世界最大規模の木造建築物」／「重伝建地区のなかで全国最多」。短縮しない。
 *  - 法隆寺の「現存する世界最古の木造建築群」は県の観光公式の表現。出典を明示して書く。
 *  - 東大寺の大仏をはじめ、堂内の仏像は絵に描かせない。建物の外観だけを描く。
 *  - 高松塚古墳・キトラ古墳の壁画も描かせない。
 *  - 奈良公園のシカは国の天然記念物で野生動物。餌やりや接触を勧める書き方をしない。
 *  - 鹿肉は採用しない。
 *  - 奈良漬の「1300年以上」は観光協会のみの記述。書かない。
 *  - 生の柿・柿なますは、島根の干し柿・京都の古老柿なますと絵で分けにくい。使わない。
 *
 * 本番画像は public/assets/foods/nara/ に置く。
 *
 * 2026-10-02 確定案（audit/_確定案.csv）で料理を入れ替えた。
 * - 外した品：奈良漬・しきしき・でんがら・いもぼた・七色お和え・大和の雑煮（店で食べられる品に差し替え）
 * - 柿：五條市観光協会のページにある「生産量・味と名実ともに日本一」は、市の観光協会の言い方で国の統計で確かめていないので書かない（県の資料は全国2位）
 * - 柿：ハウス柿・富有の全国一位は検索結果の要約に出たが、開いたページで確かめられなかったので書かない
 * - 柿：柿の専門店などの店名は書かない
 * - わらび餅：「足利時代から奈良名物」は検索結果の観光サイト要約に出たが、開いた公式ページで確かめていないので書かない
 * - わらび餅：本蕨粉だけで作るものは少ない（市販品の多くは別のでんぷん）という事実は出典にあるが、店の品質の比較に読めるので書かない
 * - わらび餅：特定の和菓子店・茶屋の名は書かない
 * - 葛きり：葛切りの作り方（葛粉を水で溶いて板状に固め、細く切る）と黒蜜で食べることは、検索結果や店の紹介文には出るが、国・県の公式ページで確かめられなかったので書かない
 * - 葛きり：吉野山観光協会のページには店紹介の中に「吉野名物の葛きり」とあるが、店の紹介文なので説明文には使っていない
 * - 葛うどん：葛粉を麺に練り込むのか、つゆに葛でとろみをつけるのかは、公式資料で確かめられなかったので書かない（出典は「葛で作った」まで）
 * - 葛うどん：卵とじであることは公式資料にないので書かない
 * - 葛うどん：「ツルッとしたのど越し」は吉野山観光協会の店紹介文にある表現だが、source と別ページで、特定店の紹介なので description には入れない
 * - 天理ラーメン：1968年の屋台から始まったという話は選定メモ（店情報）にあるだけで、公式資料で確かめられないので書かない
 * - 天理ラーメン：発祥の店・系列店の名は書かない
 * - 品名「奈良七種釜めし」を「奈良の釜めし」に地元で通じる呼び名に改めた（2026-10-11 地元民レビュー。同じ料理なので ID はそのまま）。1店の献立名に見えるため
 * - 奈良七種釜めし：「七種」の具の内訳は特定の店の献立なので書かない（公式ページに「七種」の語はない）
 * - 奈良七種釜めし：創業年・店名は書かない
  * - 2026-10-12 地元民レビューで「奈良茶飯」を外し「かしわのすき焼き」を入れた（地元の人がまず挙げる品のため。旧IDは idMigrations の retiredItems）
 */

import { attachHulls } from '../../utils/itemShape';
import type { RewardLink, StageDefinition, StageItemDefinition } from '../types';

import { naraSceneryTour } from './naraScenes';
import { NARA_FOOD_HULLS } from './naraFoodShapes.generated';

/** 「食べに行く」導線の既定リンク（特定店の宣伝にならないよう検索リンクにする）。 */
function searchLinks(area: string, dish: string): RewardLink[] {
  return [
    {
      label: '地図で探す',
      url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${area} ${dish}`)}`,
    },
    {
      label: 'お店を調べる',
      url: `https://www.google.com/search?q=${encodeURIComponent(`${area} ${dish}`)}`,
    },
  ];
}

const FOOD_ITEMS: StageItemDefinition[] = [
  {
    id: 'kuzu-mochi',
    level: 1,
    name: '葛餅',
    shortName: 'くずもち',
    image: '/assets/foods/nara/01_kuzu_mochi.webp',
    radius: 17,
    mass: 1,
    score: 2,
    description: '吉野の水が、四角く澄む。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/kuzu_mochi_nara.html',
    icon: { label: 'くずもち', shape: 'mochi', baseColor: '#e0dcd0', accentColor: '#8a6030' },
    reward: {
      unlockScore: 200,
      area: '吉野町ほか吉野地方',
      headline: '吉野の冷たい水と寒さが生む本葛を練り上げた、向こう側が透けるほど澄んだ四角い餅。',
      tip: '葛粉の名は、葛の根を掘って粉にした吉野の山の人々に由来する。冬の地下水にくり返しさらす「吉野晒」で二、三か月かけて精製され、その水と寒さが質の高い葛粉を生む。',
      links: searchLinks('吉野町', '葛餅 吉野本葛'),
    },
  },
  {
    id: 'nara-kaki',
    level: 2,
    name: '柿',
    shortName: '柿',
    image: '/assets/foods/nara/02_nara_kaki.webp',
    radius: 21,
    mass: 1.3,
    score: 4,
    description: '奈良県は柿の栽培面積と出荷量で和歌山県に次ぐ全国2位。渋柿の刀根早生と甘柿の富有が多い。9月中旬の刀根早生に始まり、平核無、11月からの富有と、品種を替えて冬まで出荷が続く。',
    source:
      'https://www.pref.nara.lg.jp/n128/item315732.html',
    icon: { label: '柿', shape: 'berry', baseColor: '#e8761e', accentColor: '#3f6b2a' },
    reward: {
      unlockScore: 500,
      area: '五條市・吉野地域',
      headline: '品種をつないで秋を通して出る',
      tip: '県内でとれる柿の約7割を五條・吉野地区が占める。五條の柿の代表は、形が大きく色つやのよい甘柿の富有柿。',
      links: searchLinks('五條市', '柿'),
      official: [{ label: '奈良県「奈良県での柿生産」', url: 'https://www.pref.nara.lg.jp/n128/item315732.html' }, { label: '五條市観光協会「柿」', url: 'https://www.gojo.ne.jp/g-kanko/gourmet/kaki/index.html' }],
    },
  },
  {
    id: 'warabi-mochi',
    level: 3,
    name: 'わらび餅',
    shortName: 'わらび餅',
    image: '/assets/foods/nara/03_warabi_mochi.webp',
    radius: 26,
    mass: 1.7,
    score: 8,
    description: 'ワラビの根のでんぷんからとる蕨粉に砂糖と水を加え、焦がさないように火にかけて練り、半透明にしたもち。冷ましてきな粉や黒蜜をかけて食べる。奈良県内全域で一年中食べられ、とくに春から夏によく食べられる。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/warabi_mochi_nara.html',
    icon: { label: 'わらび餅', shape: 'mochi', baseColor: '#c9a466', accentColor: '#7a5a2a' },
    reward: {
      unlockScore: 1000,
      area: '奈良市ほか県内全域',
      headline: 'ワラビの根のでんぷんで作るもち',
      tip: '若草山の山焼きのあとにワラビがよく生え、奈良公園の鹿も食べなかったため群生し、奈良は蕨粉の産地になった。宝永6年（1709年）の記録に蕨餅の茶屋が多く並んだとある。',
      links: searchLinks('奈良市', 'わらび餅'),
    },
  },
  {
    id: 'chagayu',
    level: 4,
    name: '茶粥',
    shortName: '茶がゆ',
    image: '/assets/foods/nara/04_chagayu.webp',
    radius: 30,
    mass: 2.2,
    score: 16,
    description: '大和の朝は、茶粥から。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/chagayu_nara.html',
    icon: { label: '茶がゆ', shape: 'pot', baseColor: '#c8a878', accentColor: '#f0ece0' },
    reward: {
      unlockScore: 1800,
      area: '奈良県内全域',
      headline: '煮出したほうじ茶でごはんを炊いた、さらりと軽い奈良の朝ごはん。',
      tip: '「大和の朝は茶粥で明ける」と言われるほど日常の食事だった。東大寺のお水取りにこもる僧の食事の記録にも、その原型とみられる名が残る。',
      links: searchLinks('奈良市', '茶粥'),
    },
  },
  {
    id: 'miwa-somen',
    level: 5,
    name: '三輪素麺',
    shortName: '三輪そうめん',
    image: '/assets/foods/nara/05_miwa_somen.webp',
    radius: 36,
    mass: 2.8,
    score: 32,
    description: '糸のように、細く長く。',
    source: 'https://www.maff.go.jp/j/shokusan/gi_act/register/',
    icon: { label: '三輪そうめん', shape: 'ramen', baseColor: '#f4f2ec', accentColor: '#c8a858' },
    reward: {
      unlockScore: 3000,
      area: '桜井市（三輪地域）',
      headline: '桜井市三輪で手延べされる、糸のように細い乾麺。束ねた姿そのものが名物。',
      tip: '国の地理的表示に登録された産品。三輪に広まった小麦を粉にし、水でこねて糸状に延ばしたのが始まりと伝えられる。冬は温かい汁で「にゅうめん」にして食べる。',
      links: searchLinks('桜井市', '三輪そうめん'),
    },
  },
  {
    id: 'kuzukiri',
    level: 6,
    name: '葛きり',
    shortName: '葛きり',
    image: '/assets/foods/nara/06_kuzukiri.webp',
    radius: 42,
    mass: 3.5,
    score: 64,
    description: 'クズの根からとれるでん粉を水でさらして精製した吉野本葛を使う甘味。精製は雑菌の増えにくい冬に行うため「寒晒し」「吉野晒し」と呼ばれる。葛を料理に使うのは鎌倉から室町時代以降で、そのころから葛切りの記述が現れる。',
    source:
      'https://www.pref.nara.lg.jp/n128/item319203.html',
    icon: { label: '葛きり', shape: 'noodle-bowl', baseColor: '#eef2f2', accentColor: '#2a1a12' },
    reward: {
      unlockScore: 4500,
      area: '吉野町／宇陀市',
      headline: '吉野本葛をそのまま味わう',
      tip: '葛という名は、国栖（くず）の人が葛の根からでん粉をとって売り歩いたことに由来するとされる。',
      links: searchLinks('吉野町', '葛きり'),
      official: [{ label: '奈良県「吉野本葛 / 奈良の食文化」', url: 'https://www.pref.nara.lg.jp/site/foodculture/1006.html' }, { label: '農林水産省「にっぽん伝統食図鑑」吉野本葛、葛餅', url: 'https://www.maff.go.jp/j/keikaku/syokubunka/traditional-foods/menu/yosino_honkuzu.html' }],
    },
  },
  {
    id: 'kuzu-udon',
    level: 7,
    name: '葛うどん',
    shortName: '葛うどん',
    image: '/assets/foods/nara/07_kuzu_udon.webp',
    radius: 46,
    mass: 4.4,
    score: 128,
    description: '吉野名物の葛で作ったうどん。吉野山の郷土料理の店で、シメサバを柿の葉で包んだ柿の葉すしなどと並んで出される。桜や紅葉の吉野の景色を眺めながら味わう一杯。',
    source:
      'https://naraiko.pref.nara.jp/ja/spots/bgwufpzfh0',
    icon: { label: '葛うどん', shape: 'noodle-bowl', baseColor: '#f0e2b0', accentColor: '#f2c94c' },
    reward: {
      unlockScore: 6500,
      area: '吉野町（吉野山）',
      headline: '吉野名物の葛で作るうどん',
      tip: '葛粉はクズの根から採ったでん粉を水で晒して精製する。晒しは雑菌が増えにくい冬に行うため「寒晒し」「吉野晒し」とも呼ばれる。',
      links: searchLinks('吉野山', '葛うどん'),
      official: [{ label: '吉野山観光協会「食べる」', url: 'https://yoshinoyama-kankou.com/gourmet/' }, { label: '奈良県「吉野本葛について」', url: 'https://www.pref.nara.lg.jp/n128/item319203.html' }],
    },
  },
  {
    id: 'kakinoha-zushi-nara',
    level: 8,
    name: '柿の葉寿司',
    shortName: '柿の葉寿司',
    image: '/assets/foods/nara/08_kakinoha_zushi.webp',
    radius: 51,
    mass: 5.4,
    score: 256,
    description: '葉をひらけば、銀の鯖。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/kakinoha_zushi_nara.html',
    icon: { label: '柿の葉寿司', shape: 'roe', baseColor: '#5a7a38', accentColor: '#b8c0c8' },
    reward: {
      unlockScore: 9000,
      area: '五條市・吉野地方',
      headline: '塩でしめた鯖を3、4ミリに薄く切って酢飯にのせ、柿の葉で包んで一晩重しをかけた押し寿司。',
      tip: '江戸時代、和歌山の漁師が熊野灘の夏の鯖を塩でしめ、吉野川沿いの村に夏祭り用として売ったのが始まりという説がある。柿の葉のタンニンには保存を助けるはたらきがあるとされる。',
      links: searchLinks('五條市', '柿の葉寿司'),
    },
  },
  {
    id: 'tenri-ramen',
    level: 9,
    name: '天理ラーメン',
    shortName: '天理ラーメン',
    image: '/assets/foods/nara/09_tenri_ramen.webp',
    radius: 57,
    mass: 6.6,
    score: 512,
    description: '豚骨と鶏がらに、ニンニクや豆板醤で味をつけた辛味のあるスープのラーメン。スープは赤みがかり、炒めた白菜と豚肉、ニラをたっぷりのせる。奈良のご当地ラーメンとして親しまれている。',
    source:
      'https://narashikanko.or.jp/feature/gourmet',
    icon: { label: '天理ラーメン', shape: 'ramen', baseColor: '#b8432a', accentColor: '#e8e0b8' },
    reward: {
      unlockScore: 12000,
      area: '天理市ほか奈良県内',
      headline: '白菜を山盛りにした赤いスープ',
      tip: '寒い日だけでなく暑い日にも食べられている、ボリュームのある地元のラーメン。',
      links: searchLinks('天理市', '天理ラーメン'),
    },
  },
  {
    id: 'nara-kamameshi',
    level: 10,
    name: '奈良の釜めし',
    shortName: '釜めし',
    image: '/assets/foods/nara/10_nara_kamameshi.webp',
    radius: 63,
    mass: 8,
    score: 1024,
    description: '奈良では醤油味の炊き込みご飯を「色ご飯」と呼ぶ。人参・しいたけ・ごぼう・薄揚げが一般的で、えんどう・たけのこなど旬の具も入れて炊く。村の行事でふるまわれ、家庭でも日常的に食べられてきた。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/irogohan_nara.html',
    icon: { label: '釜めし', shape: 'pot', baseColor: '#2a2a2a', accentColor: '#e89a4a' },
    reward: {
      unlockScore: 16000,
      area: '奈良市ほか県内全域',
      headline: '色ご飯につながる炊き込みご飯',
      tip: '米が貴重だった奈良時代に、あわなどを混ぜてかさ増ししたのが始まりとされる。奈良市内の釜めしの店で、色ご飯につながる炊き込みご飯を味わえる。',
      links: searchLinks('奈良市', '釜めし'),
      official: [{ label: '奈良市観光協会「奈良のおすすめグルメ21選」（釜めし・色ご飯）', url: 'https://narashikanko.or.jp/feature/gourmet' }],
    },
  },
  {
    id: 'kashiwa-sukiyaki',
    level: 11,
    name: 'かしわのすき焼き',
    shortName: 'かしわのすき焼き',
    image: '/assets/foods/nara/11_kashiwa_sukiyaki.webp',
    radius: 70,
    mass: 9.6,
    score: 2048,
    description: '関西で食用の鶏肉を呼ぶ「かしわ」のすき焼き。鶏肉に白菜・しらたき・焼き豆腐・ねぎ・しいたけ・春菊などを煮て、溶いた生卵につけて食べる。天満宮の守護神が牛であることから、秋祭りの祝いの席では鶏のすき焼きが食べられてきた。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/kashiwa_no_sukiyaki_nara.html',
    icon: { label: 'かしわ', shape: 'hotpot', baseColor: '#2a2a2a', accentColor: '#c89a5a' },
    reward: {
      unlockScore: 22000,
      area: '奈良県内全域',
      headline: '牛ではなく鶏のすき焼き',
      tip: '家庭で親から子へ受け継がれ、学校給食や県内の飲食店でも出される。締めに三輪素麺を入れる食べ方もすすめられている。',
      links: searchLinks('奈良市', 'かしわ すき焼き'),
    },
  },
  {
    id: 'asuka-nabe',
    level: 12,
    name: '飛鳥鍋',
    shortName: '飛鳥鍋',
    image: '/assets/foods/nara/12_asuka_nabe.webp',
    radius: 78,
    mass: 11.4,
    score: 4096,
    description: 'まっ白な湯気の、鍋。',
    source:
      'https://www.maff.go.jp/j/keikaku/syokubunka/k_ryouri/search_menu/menu/asuka_nabe_nara.html',
    icon: { label: '飛鳥鍋', shape: 'hotpot', baseColor: '#f0f0ec', accentColor: '#c8503a' },
    reward: {
      unlockScore: 30000,
      area: '奈良盆地中南部',
      headline: '鶏だしに牛乳を加え、白味噌で味をととのえる、まっ白なスープの鶏鍋。',
      tip: '飛鳥時代、大陸から牛乳がもたらされたことに由来すると伝えられ、のちに鶏肉を牛乳で煮たのが飛鳥鍋の始まりとされる。今の形は昭和のはじめ、地元の乳製品を使ってできあがった。',
      links: searchLinks('奈良県', '飛鳥鍋'),
    },
  },
];

/** 得点は 2 ^ level を基準にしている（GAME_TUNING.score で方式変更可能）。 */
export const naraFoodStage: StageDefinition = {
  regionId: 'nara',
  regionName: '奈良県',
  mode: 'food',
  title: '奈良めしマージ',
  theme: {
    primaryColor: '#a03a30',
    secondaryColor: '#c8a848',
    accentColor: '#e0c470',
    backgroundColor: '#181210',
  },
  /** 背景ツアー「奈良めぐり」。軸は一日の時間と季節。朝の奈良公園から、秋の明日香へ。 */
  scenery: {
    tour: naraSceneryTour,
  },
  items: attachHulls(FOOD_ITEMS, NARA_FOOD_HULLS),
};
